import SearchQuery from '@vue-storefront/core/lib/search/searchQuery'

export function prepareProductsQuery (payload) {
  let productsQuery = new SearchQuery()

  let categoryIds = payload.ids;

  productsQuery = productsQuery
    .applyFilter({key: 'visibility', value: {'in': [2, 3, 4]}})
    .applyFilter({key: 'status', value: {'in': [0, 1]}})
  productsQuery = productsQuery.applyFilter({key: 'stock.is_in_stock', value: {'eq': true}})

  productsQuery = productsQuery.applyFilter({key: 'category_ids', value: { 'in': categoryIds }});

  return productsQuery;
}

export function productsTotal (category) {
  return new Promise(resolve => {
    let categoryIds = [category.entity_id];
    let childData = category.children_data;
    if (childData) {
      let recurGetIds = (childData) => {
        childData.map(child => {
          categoryIds.push(child.entity_id)
          if (child.children_data) {
            recurGetIds(child.children_data)
          }
        })
      }
      recurGetIds(childData)
    }
    let productsQuery = prepareProductsQuery({ids: categoryIds})
    resolve(productsQuery);
  })
}
